import 'core-js/stable';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import MomentUtils from '@date-io/moment';
import * as Sentry from '@sentry/react';
import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MuiThemeProvider } from '@material-ui/core';
import { BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { render } from 'react-dom';

import Root from 'redux/root.container';
import { theme } from 'utilities/theme';

import * as serviceWorker from './serviceWorker';

import './index.css';

const BASENAME = process.env.PUBLIC_URL || '/';

const history = createBrowserHistory();

Sentry.init({
  dsn: 'https://299a16e2e51f12008cf42ec0f79c6019@o4505155755048960.ingest.us.sentry.io/4509548087803904',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
});

console.log(`APP VERSION: ${process.env.REACT_APP_VERSION}`);
console.log(`ENVIRONMENT: ${process.env.REACT_APP_ENVIRONMENT_NAME}`);
console.log(`SUPPORT: ${process.env.REACT_APP_SERVICE_DESK_URL}`);

const onRedirectCallback = appState => {
  history.replace(appState?.returnTo || window.location.pathname);
};

// const whyDidYouRender = require('@welldone-software/why-did-you-render');
// whyDidYouRender(React, {
//   trackAllPureComponents: true,
//   trackHooks: true,
//   logOwnerReasons: true,
//   titleColor: 'green',
//   diffNameColor: 'aqua',
// });

render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH_0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH_0_CLIENT_ID}
    redirectUri={`${window.location.origin}${process.env.REACT_APP_AUTH_0_CALLBACK_URI}`}
    audience={process.env.REACT_APP_AUTH_0_AUDIENCE}
    scope={process.env.REACT_APP_AUTH_0_SCOPES}
    onRedirectCallback={onRedirectCallback}
  >
    <Router basename={BASENAME} history={history}>
      <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Root />
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    </Router>
  </Auth0Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
